var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-fade" }, [
    _vm.step === 1
      ? _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.cancelation,
                expression: "!cancelation"
              }
            ],
            staticClass: "back-btn",
            on: { click: _vm.callCancelation }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "11",
                  height: "20",
                  viewBox: "0 0 11 20",
                  fill: "none"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M9.68663 0.00102615C9.35042 0.00102615 9.01441 0.136253 8.75801 0.406494L0 9.63728L8.75801 18.8681C9.27081 19.4086 10.1024 19.4086 10.6152 18.8681C11.1283 18.3276 11.1283 17.4511 10.6152 16.9106L3.71447 9.63728L10.6152 2.36399C11.1283 1.8235 11.1283 0.946976 10.6152 0.406494C10.3588 0.136253 10.0228 0.00102615 9.68663 0.00102615Z",
                    fill: "#1C23C3"
                  }
                })
              ]
            ),
            _vm._v("\n    Back\n  ")
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.cancelation,
            expression: "!cancelation"
          }
        ],
        staticClass: "login"
      },
      [
        _vm.step === 0
          ? _c(
              "button",
              { staticClass: "login-close", on: { click: _vm.modalClose } },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "23",
                      height: "23",
                      viewBox: "0 0 23 23",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M2.00342 2L20.6685 20.6651",
                        stroke: "black",
                        "stroke-width": "3",
                        "stroke-linecap": "round"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M20.665 2L1.99993 20.6651",
                        stroke: "black",
                        "stroke-width": "3",
                        "stroke-linecap": "round"
                      }
                    })
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "login-form" },
          [
            _vm.step === 0
              ? [
                  _c(
                    "p",
                    { staticClass: "login-title" },
                    [
                      _vm._v("\n          Purchase\n          "),
                      _vm.pixtokens
                        ? [_vm._v("Pixtokens")]
                        : [_vm._v("Pixcoins")]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.allCoins
                    ? _c("p", { staticClass: "login-subtitle" }, [
                        _vm._v(
                          "\n          You need " +
                            _vm._s(_vm.requiredToBuy) +
                            "\n          "
                        ),
                        _c(
                          "svg",
                          {
                            staticClass: "nft-icon",
                            attrs: {
                              width: "25",
                              height: "24",
                              viewBox: "0 0 25 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M12.0124 23.4426C18.6467 23.4426 24.0248 18.1948 24.0248 11.7213C24.0248 5.24781 18.6467 0 12.0124 0C5.37814 0 0 5.24781 0 11.7213C0 18.1948 5.37814 23.4426 12.0124 23.4426Z",
                                fill: "#34A3E6"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M21.3554 11.5684C21.3554 16.7284 17.1724 20.9114 12.0124 20.9114C6.85243 20.9114 2.66943 16.7284 2.66943 11.5684",
                                stroke: "#84CCF8",
                                "stroke-width": "1.5"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M12.0124 20.9114C6.85243 20.9114 2.66943 16.7284 2.66943 11.5684",
                                stroke: "#E4F1FA",
                                "stroke-width": "1.5"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M21.3554 12.0149C21.3554 6.85488 17.1724 2.67188 12.0124 2.67188C6.85243 2.67188 2.66943 6.85488 2.66943 12.0149",
                                stroke: "#034166",
                                "stroke-width": "1.5"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M21.3552 12.0149C21.3552 6.85488 17.1722 2.67188 12.0122 2.67188",
                                stroke: "#E4F1FA",
                                "stroke-width": "1.5"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M6.22852 8.00977H7.24621L8.83892 11.7348V8.00977H10.0512V15.1766H9.06893L7.47584 11.2129V15.177H6.22852V8.00977Z",
                                fill: "white"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M11.1299 8.00977H14.1558V9.00974H12.5808V10.9388H13.9168V11.9561H12.5808V15.177H11.1299V8.00977Z",
                                fill: "url(#paint0_linear_7768_33021)"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M15.5639 9.0893H14.458V8.00977H18.1212V9.0893H17.033V15.177H15.5643V9.0893H15.5639Z",
                                fill: "white"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "defs",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "paint0_linear_7768_33021",
                                      x1: "5.49221",
                                      y1: "18.5412",
                                      x2: "20.3832",
                                      y2: "2.28208",
                                      gradientUnits: "userSpaceOnUse"
                                    }
                                  },
                                  [
                                    _c("stop", {
                                      attrs: { "stop-color": "white" }
                                    }),
                                    _vm._v(" "),
                                    _c("stop", {
                                      attrs: {
                                        offset: "1",
                                        "stop-color": "white"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v("\n          to mint your NFTS.\n        ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "purchase-variants" },
                    _vm._l(_vm.coinPacks, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "purchase-block",
                          on: {
                            click: function($event) {
                              return _vm.nextStep(item)
                            }
                          }
                        },
                        [
                          item.pixtokens
                            ? _c("div", { staticClass: "image-holder" }, [
                                _c("img", {
                                  staticClass: "sparcle",
                                  attrs: {
                                    src: require("../../../../public/img/icons/nft_sparkle.gif"),
                                    width: "50",
                                    height: "50",
                                    alt: "nft sparkle"
                                  }
                                }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "purchase-image",
                                  attrs: {
                                    src: require("../../../../public/img/icons/purchase-icon-token.svg"),
                                    width: "58",
                                    height: "51",
                                    loading: "lazy",
                                    alt: "purchase icon"
                                  }
                                })
                              ])
                            : _c("img", {
                                staticClass: "purchase-image",
                                attrs: {
                                  src: require("../../../../public/img/icons/purchase-icon.svg"),
                                  width: "65",
                                  height: "64",
                                  loading: "lazy",
                                  alt: "purchase icon"
                                }
                              }),
                          _vm._v(" "),
                          _c("div", { staticClass: "purchase-value" }, [
                            _c("span", { staticClass: "purchase-price" }, [
                              _vm._v(_vm._s(Number(item.coins)))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "purchase-currency" },
                              [
                                item.pixtokens
                                  ? [_vm._v("tokens")]
                                  : [_vm._v("px")]
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "purchase-buy" }, [
                            _vm._v("$" + _vm._s(item.price))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              : [
                  _c("p", { staticClass: "login-title" }, [
                    _vm._v("\n          Payment Method\n        ")
                  ]),
                  _vm._v(" "),
                  _c("div", { ref: "paypal", staticClass: "payment" })
                ]
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _vm.cancelation
      ? _c("div", { staticClass: "login" }, [
          _c("div", { staticClass: "login-form" }, [
            _c("p", { staticClass: "login-title" }, [
              _vm._v("\n        Cancel Purchase\n      ")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "login-text" }, [
              _vm._v("Are you sure you want to cancel?")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttons" }, [
              _c(
                "button",
                { staticClass: "secondary-btn", on: { click: _vm.modalClose } },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "main-btn",
                  on: { click: _vm.continuePurchase }
                },
                [_vm._v("Back")]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }